<template>
  <v-row
    v-if="Array.isArray(backendFiles)"
    class="images-uploaded"
    :style="{padding: padding + 'px' }"
  >
    <v-col
      v-for="(file) in backendFiles"
      :key="file.id || file._id"
      :data-cy="dataCy"
      cols="auto"
      class="btn--container p-0 mr-2"
    >
      <div class="file-card">
        <div
          v-if="showThumbnail"
          class="image-frame"
        >
          <img
            :src="fileBlobUrls[file.id]"
            alt="thumbnail"
            class="image-thumbnail"
          >
        </div>

        <div class="file-actions">
          <v-icon
            v-if="!preview"
            color="#26384B"
            big
            :disabled="forceDisableRemove || disabled"
            @click="$emit('removeFiles', file.id || file._id)"
          >
            mdi-close
          </v-icon>
          <v-btn
            text
            outlined
            small
            class="ma-1 file-name-btn"
            style="border: none !important; font-weight: 400; font-style: italic;margin: 0px"
            :disabled="disabled"
            :title="file.link ? file.link.fileName : file.fileName || file.title || ''"
            @click="downloadFile(file)"
          >
            {{ getShortFileName(file.link ? file.link.fileName : file.fileName || file.title || '') }}
          </v-btn>
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
    props: {
        backendFiles: {
            type: [Array, String],
            default: () => ([]),
        },
        preview: {
            type: Boolean,
            default: false,
        },
        padding: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        dataCy: {
            type: String,
            default: '',
        },
        forceDisableRemove: {
            type: Boolean,
            default: false,
        },
        onDownloadFile: {
            type: Function,
            default: null,
        },
        showThumbnail: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fileBlobUrls: {},
        };
    },
    watch: {
        backendFiles: {
            immediate: true,
            handler(files) {
                if (!Array.isArray(files)) return;
                files.forEach(file => {
                    if (file && file.id && !this.fileBlobUrls[file.id]) {
                        this.fetchBlobUrl(file);
                    }
                });
            },
        },
    },
    methods: {
        async downloadFile(file) {
            if (this.onDownloadFile) {
                this.onDownloadFile(file);
            } else {
            // eslint-disable-next-line no-underscore-dangle
                const { data } = await this.$rq.downloadFile(file.id || file._id);
                this.$utils.saveFileOnDisk(data, file.link.fileName || file.fileName);
            }
        },
        isImageFile(file) {
            const name = (file.link?.fileName || '').toLowerCase();
            return name.endsWith('.png') || name.endsWith('.jpg') || name.endsWith('.jpeg') || name.endsWith('.svg');
        },
        async fetchBlobUrl(file) {
            const blob = await this.$rq.getFileUrl(file.id);
            if (blob instanceof Blob) {
                this.$set(this.fileBlobUrls, file.id, URL.createObjectURL(blob));
            } else if (typeof blob === 'string') {
                this.$set(this.fileBlobUrls, file.id, blob);
            }
        },
        getShortFileName(name) {
            if (!name) return '';
            const max = 20; // total length to show
            if (name.length <= max) return name;
            const extMatch = name.match(/(\.[^.]*)$/);
            const ext = extMatch ? extMatch[1] : '';
            const base = name.replace(ext, '');
            return `${base.slice(0, 10) }...${ base.slice(-3) }${ext}`;
        },
    },
};
</script>
<style scoped>
  .btn--container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    border-radius: 4px;
    padding: 0px 3px !important;
  }
  ::v-deep .v-btn:not(.v-btn--round).v-size--small {
    height: auto;
  }
  .file-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
}
  .image-frame {
    background: #fff;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 150px;
    box-sizing: border-box;
  }
  .image-thumbnail {
    max-width: 100%;
    max-height: 100%;
    border-radius: 8px;
    display: block;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  }
  .file-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  width: 200px;
  gap: 4px;
  border: 1px solid #26384B;
}
.file-name-btn {
  max-width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
}
</style>
